import React from 'react'

const nf = new Intl.NumberFormat('de-CH')

export const Summary = (data: summaryProps) => {
  return (
    <>
      <div className='summary'>
        {data.cases > 9999 ? nf.format(data.cases) : data.cases} cas
        confimés dans <br />
        <span className='countries'>
          &nbsp;{data.countries} pays&nbsp;
        </span>{' '}
        avec&nbsp;
        <span className='death'>
          {' '}
          &nbsp;{data.death > 9999 ? nf.format(data.death) : data.death} morts.
          &nbsp;
        </span>
      </div>
      <div className='sources'>
        Statut: monde{' '}
        {data.updated.getDate() -
          1 +
          '.' +
          (+data.updated.getMonth() + 1) +
          '.' +
          data.updated.getFullYear()}
        / Suisse:{' '}
        {data.updated.getDate() +
          '.' +
          (+data.updated.getMonth() + 1) +
          '.' +
          data.updated.getFullYear()}
        , Source : Université Johns Hopkins, BAG, Cantons
      </div>
    </>
  )
}
